import React from "react";
import { Vehicle, useGetVehiclesPaginatedWithSearchQuery } from "../../../api/vehiclesApi";
import VehiclesTable from "./VehiclesTable";
import { DEFAULT_DATA_TABLE_PAGE_SIZE } from "../../../constants/dataTable";
import { useDataTablePagination } from "../../../hooks/useDataTablePagination";

const VehicleTab: React.FC = () => {
  const {
    items: vehicles,
    isLoading,
    isLoadingRows,
    isLoadingMore,
    totalCount,
    hasNextPage,
    handleSearchChange,
    handleLoadMore,
  } = useDataTablePagination<Vehicle>(
    useGetVehiclesPaginatedWithSearchQuery,
    DEFAULT_DATA_TABLE_PAGE_SIZE
  );

  return (
    <VehiclesTable
      vehicles={vehicles}
      isLoading={isLoading}
      totalCount={totalCount}
      hasNextPage={hasNextPage}
      isLoadingMore={isLoadingMore}
      isLoadingRows={isLoadingRows}
      onLoadMore={handleLoadMore}
      
      // Search functionality
      enableSearch={true}
      onSearchChange={handleSearchChange}
    />
  );
};

export default VehicleTab;
